module.exports = __webpack_public_path__ + "static/media/slider2.2cb5e995.jpg";